import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/new/video_suspend.png'
import _imports_1 from '@/assets/img/new/video_play.png'
import _imports_2 from '@/assets/img/new/video_volume.png'
import _imports_3 from '@/assets/img/new/video_mute.png'
import _imports_4 from '@/assets/img/new/video_quit_fullscreen.png'
import _imports_5 from '@/assets/img/new/video_fullscreen.png'


const _withScopeId = n => (_pushScopeId("data-v-b35d99a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "control"
}
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_6 = { class: "progress" }
const _hoisted_7 = { class: "slider-demo-block" }
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "/", -1))
const _hoisted_11 = { class: "volume" }
const _hoisted_12 = { class: "volume_slider" }
const _hoisted_13 = {
  key: 0,
  src: _imports_4,
  alt: "",
  srcset: ""
}
const _hoisted_14 = {
  key: 1,
  src: _imports_5,
  alt: "",
  srcset: ""
}

import { onMounted, onUnmounted, reactive, ref, toRefs } from "vue";
import XEUtils from "xe-utils";

type TProps = {
    Url: string,
    isShowNext?: boolean,
    currTime?: number,
    datainfo: TDatainfo
}
type TDatainfo = {
    CollectionNum: number
    CommentNum: number
    Desc: string
    FabulousNum: number
    Id: number
    IsCollection: boolean
    IsFabulous: boolean
    LearningNum: number
    MaxProgress: number
    Name: string
    PlayAddress: string
    ProgressTimes: number
    VideoId: string
    VideoName: string
}
type TState = {
    videoUrl: string
    volume: number
    isVolume: boolean
    isMute: boolean
    isPlay: boolean
    isFullscreen: boolean
    totalDuration: string
    currentTime: string
    timer: number
    progressValue: number
    percent: number
    moveTimer: number
    isController: boolean
    mouseCoord: number
    lastvalue: number
    globalTimer: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'video',
  props: {
    Url: null,
    isShowNext: { type: Boolean, default: false },
    currTime: null,
    datainfo: null
  },
  emits: ['played', 'next',"CallbackTime","CallbackPause","CallbackPaly"],
  setup(__props: any, { emit: emits }) {

const props = __props as { Url: string, isShowNext: boolean, currTime?: number, datainfo: TDatainfo };

const state = reactive<TState>({
    videoUrl: '',
    volume: 50,
    isVolume: false,
    isMute: true,
    isPlay: false,
    isFullscreen: false,
    totalDuration: '',
    currentTime: '00:00',
    timer: 0,
    progressValue: 0,
    percent: 0,
    moveTimer: 0,
    isController: true,
    mouseCoord: 0,
    lastvalue: 0,
    globalTimer: 0,
})
let person = reactive({
  currTime: 0, // 当前点击以及变化的时间
  totalTime:0, // 视频总时间
  oldCurrTime:0,
  jumpTime:0,// 上一次视频的时间
  twoTime:0,
  isFisrt:0
});

const videoPlayer = ref()
const flVideo = ref()



onMounted(() => {
    flVideo.value.volume = 0.5
    loopTimer()
    resizeListener()
    setTimeout(()=>{
        load()
    },300)
})

const Props = reactive(props)
const { Url,datainfo,currTime } = toRefs(Props)

// 初始化
const load = () => {
    state.currentTime = secondTurnTime(datainfo.value?.ProgressTimes)
    state.progressValue = (datainfo.value?.ProgressTimes / flVideo.value.duration) * 100
}
// 函数
const getVidDur = () => {
    getDuration()
}
//鼠标移入
const onMouseenter = (e: MouseEvent) => {
    state.isController = true
    clearTimeout(state.moveTimer)
}
//鼠标移出
const onMouseleave = () => {
    state.moveTimer = setTimeout(() => {
        state.isController = false
    }, 2000)
}
//循环监听鼠标事件
const loopTimer = () => {
    state.globalTimer = setInterval(() => {
        if (state.lastvalue == state.mouseCoord) {
            state.isController = false
        }
        state.lastvalue = state.mouseCoord
    }, 3000)
}

//鼠标移动事件
const onMousemove = XEUtils.throttle((e: MouseEvent) => {
    state.mouseCoord = e.pageX
    state.isController = true
}, 300)

// 退出当前页时关闭视频播放
onUnmounted(() => {
    clearInterval(state.timer)
})

//是否全屏
const onFullscreen = () => {
    fullScreenToggle()
}
//
const resizeListener = () => {
    window.addEventListener('resize', function () {
        if (!isFullScreen()) {
            if (!isFullScreen()) {
                state.isFullscreen = false
            }
        }
    })
}

//是否静音
const onVolume = () => {
    if (state.isMute) {
        flVideo.value.muted = true
        state.isMute = false
    } else {
        flVideo.value.muted = false
        state.isMute = true
    }
}

//播放/暂停
const onPlay = () => {
    state.isController = true
    if (!state.isPlay) { // 播放
        flVideo.value.play()
        state.isPlay = true
        state.timer = setInterval(() => {
            handleCurrentTime()
            if (state.progressValue === 100) {
                clearInterval(state.timer)
                flVideo.value.pause()
                state.isPlay = false
                handlePlayedCallback()
            }
        }, 1000)
        emits("CallbackPaly")
    } else { // 暂停
        flVideo.value.pause()
        state.isPlay = false
        clearInterval(state.timer)
        emits("CallbackPause")
    }
}
// 拖动事件
const onTimeupdate = (ev:any) => {
    person.currTime = ev.target.currentTime //观看时长
    person.totalTime = ev.target.duration //总时长
    CallbackTime(person.currTime, person.totalTime)
}
const CallbackTime = (currentTime: number, duration: number) => {
  emits('CallbackTime', currentTime, duration)
}

//设置音量
const onChangeVolume = (val: number) => {
    state.volume = val
    flVideo.value.volume = state.volume / 100
}
//获取总时长
const getDuration = () => {
    if (isNaN(flVideo.value.duration)) {
        state.totalDuration = secondTurnTime(0)
    } else {
        state.totalDuration = secondTurnTime(flVideo.value.duration)
    }
}

//处理播放的当前时间
const handleCurrentTime = () => {
    state.currentTime = secondTurnTime(flVideo.value.currentTime)
    state.progressValue = (flVideo.value.currentTime / flVideo.value.duration) * 100
}

//进度条拖动
const handleChangeProgress = () => {
    flVideo.value.currentTime = (state.progressValue / 100) * flVideo.value.duration
    state.currentTime = secondTurnTime((state.progressValue / 100) * flVideo.value.duration)
}

//处理视频播放完成的回调函数
const handlePlayedCallback = () => {
    emits('played')
}
//==工具函数==

//秒转成时间
const secondTurnTime = (s: number) => {
    let secondTime = Math.trunc(s)
    let min = 0// 初始化分
    let h = 0// 初始化小时
    let result = ''
    if (secondTime >= 60) {//如果秒数大于等于60，将秒数转换成整数
        min = Math.trunc(secondTime / 60)//获取分钟，除以60取整数，得到整数分钟
        secondTime = Math.trunc(secondTime % 60)//获取秒数，秒数取佘，得到整数秒数
        if (min >= 60) {//如果分钟大于等于60，将分钟转换成小时
            h = Math.trunc(min / 60)//获取小时，获取分钟除以60，得到整数小时
            min = Math.trunc(min % 60) //获取小时后取佘的分，获取分钟除以60取佘的分
        }
    }
    if (h === 0) {
        result = `${min.toString().padStart(2, '0')}:${secondTime.toString().padStart(2, '0')}`
    } else {
        result = `${h.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}:${secondTime.toString().padStart(2, '0')}`
    }
    return result
}

const fullScreen = () => {
    const rfs = videoPlayer.value.requestFullScreen || videoPlayer.value.webkitRequestFullScreen || videoPlayer.value.mozRequestFullScreen || videoPlayer.value.msRequestFullscreen;
    if (typeof rfs !== 'undefined' && rfs) {
        rfs.call(videoPlayer.value);
    }
}

const exitFullScreen = () => {
    let doc: any = document
    if (doc.exitFullscreen) {
        doc.exitFullscreen();
    } else if (doc.mozCancelFullScreen) {
        doc.mozCancelFullScreen();
    } else if (doc.webkitCancelFullScreen) {
        doc.webkitCancelFullScreen();
    } else if (doc.msExitFullscreen) {
        doc.msExitFullscreen();
    }
}

const isFullScreen = () => {
    let doc: any = document
    return doc.isFullScreen || doc.mozIsFullScreen || doc.webkitIsFullScreen
}

const fullScreenToggle = () => {
    if (state.isFullscreen) {
        exitFullScreen()
        state.isFullscreen = false
    } else {
        fullScreen()
        state.isFullscreen = true
    }
}


onUnmounted(() => {
    console.log('销毁');
    clearTimeout(state.globalTimer)
})


return (_ctx: any,_cache: any) => {
  const _component_el_slider = _resolveComponent("el-slider")!

  return (_openBlock(), _createElementBlock("div", {
    class: "videoPlayer",
    ref_key: "videoPlayer",
    ref: videoPlayer,
    onContextmenu: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
    onMouseleave: onMouseleave,
    onMousemove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(onMousemove) && _unref(onMousemove)(...args)))
  }, [
    _createElementVNode("video", {
      class: "fl_video",
      ref_key: "flVideo",
      ref: flVideo,
      onMouseenter: onMouseenter,
      onCanplay: getVidDur,
      onClick: onPlay,
      onTimeupdate: onTimeupdate
    }, [
      _createElementVNode("source", {
        src: _unref(Url),
        type: "video/mp4"
      }, null, 8, _hoisted_1),
      _createElementVNode("source", {
        src: _unref(Url),
        type: "video/ogg"
      }, null, 8, _hoisted_2)
    ], 544),
    (state.isController)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "play",
            onClick: onPlay
          }, [
            (state.isPlay)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : (_openBlock(), _createElementBlock("img", _hoisted_5))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_slider, {
                modelValue: state.progressValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.progressValue) = $event)),
                "show-tooltip": false,
                onChange: handleChangeProgress
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString(state.currentTime), 1),
              _hoisted_10,
              _createElementVNode("span", null, _toDisplayString(state.totalDuration), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              (state.isMute)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _imports_2,
                    alt: "",
                    onClick: onVolume
                  }))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _imports_3,
                    alt: "",
                    onClick: onVolume
                  })),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_slider, {
                  modelValue: state.volume,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.volume) = $event)),
                  vertical: "",
                  height: "100px",
                  onChange: onChangeVolume
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", {
              class: "fullscreen",
              onClick: onFullscreen
            }, [
              (state.isFullscreen)
                ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                : (_openBlock(), _createElementBlock("img", _hoisted_14))
            ]),
            _renderSlot(_ctx.$slots, "default")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 544))
}
}

})